export const SKIP_DJ_START = 'moderation/SKIP_DJ_START';
export const SKIP_DJ_COMPLETE = 'moderation/SKIP_DJ_COMPLETE';

export const MOVE_USER_START = 'moderation/MOVE_USER_START';
export const MOVE_USER_COMPLETE = 'moderation/MOVE_USER_COMPLETE';

export const REMOVE_USER_START = 'moderation/REMOVE_USER_START';
export const REMOVE_USER_COMPLETE = 'moderation/REMOVE_USER_COMPLETE';

export const MUTE_USER_START = 'moderation/MUTE_USER_START';
export const MUTE_USER_COMPLETE = 'moderation/MUTE_USER_COMPLETE';
export const UNMUTE_USER_START = 'moderation/UNMUTE_USER_START';
export const UNMUTE_USER_COMPLETE = 'moderation/UNMUTE_USER_COMPLETE';

export const BAN_USER_START = 'moderation/BAN_USER_START';
export const BAN_USER_COMPLETE = 'moderation/BAN_USER_COMPLETE';

export const ADD_USER_ROLES_START = 'moderation/ADD_USER_ROLES_START';
export const ADD_USER_ROLES_COMPLETE = 'moderation/ADD_USER_ROLES_COMPLETE';
export const REMOVE_USER_ROLES_START = 'moderation/REMOVE_USER_ROLES_START';
export const REMOVE_USER_ROLES_COMPLETE = 'moderation/REMOVE_USER_ROLES_COMPLETE';
